import { config } from "../config/config";
import * as Sentry from "@sentry/browser";
import { network } from "web-utils-network";
import { isLowEndLG } from "../utils/checkLgNewModel";
export async function getGlobalConfig() {
  const avodConifg = (await config.get()?.avod) || {}; //  local config values
  try {
    const promptcdnUrl = await config.get()?.promptCdnConfig; // cdn config
    const timeoutPromise = new Promise((resolve, reject) => setTimeout(() => resolve({}), 30000)); // Adding a timeout of 30 seconds to the fetch call

    const fetchPromise = fetch(promptcdnUrl);
    const response = await Promise.race([fetchPromise, timeoutPromise]);
    if (response instanceof Response) {
      const promptConfig = await response.json();
      const mergedObject = deepMergeWithPriority(promptConfig?.avod, avodConifg);
      return mergedObject;
    } else {
      if (avodConifg) return avodConifg;
    }
  } catch (error) {
    if (avodConifg) return avodConifg;
    //Sentry.captureException(error);
    throw error;
  }
}

/**
 * function deepMergeWithPriority scope deep merge two nested JSON objects in JavaScript,
 * and give priority to the values from the first object when the same key exists in both objects,
 *  */

function deepMergeWithPriority(obj1, obj2) {
  if (typeof obj1 !== "object" || typeof obj2 !== "object") {
    return obj1;
  }

  for (const key in obj2) {
    if (obj2.hasOwnProperty(key)) {
      if (obj1.hasOwnProperty(key)) {
        if (typeof obj1[key] === "object" && typeof obj2[key] === "object") {
          obj1[key] = deepMergeWithPriority(obj1[key], obj2[key]);
        } else {
          obj1[key] = obj1[key];
        }
      } else {
        obj1[key] = obj2[key];
      }
    }
  }

  return obj1;
}

export async function getRemoteConfig() {
  const fallback = (await config.get()?.remoteConfigFallback) || {}; //  local config values
  try {
    const cdnConfigUrl = await config.get()?.remoteConfig; // cdn config
    if (!isLowEndLG()) {
      const timeoutPromise = new Promise((resolve, reject) => setTimeout(() => resolve({}), 60000)); // Adding a timeout of 30 seconds to the fetch call

      const fetchPromise = fetch(cdnConfigUrl);
      const response = await Promise.race([fetchPromise, timeoutPromise]);
      if (response instanceof Response) {
        const configData = await response.json();
        const mergedObject = deepMergeWithPriority(configData, fallback);
        return mergedObject;
      } else {
        if (fallback) return fallback;
      }
    } else {
      const response = await network.get(cdnConfigUrl);
      return response.data;
    }
  } catch (error) {
    if (fallback) return fallback;
    //Sentry.captureException(error);
    throw error;
  }
}

export async function getRemoteProfileScreenBackGrounds() {
  try {
    const cdnConfigUrl = await config.get()?.profileScreenBackGround; // cdn profile slide show  config
    if (!isLowEndLG()) { 
      const timeoutPromise = new Promise((resolve, reject) => setTimeout(() => resolve({}), 30000)); // Adding a timeout of 30 seconds to the fetch call
      const fetchPromise = fetch(cdnConfigUrl);
      const response = await Promise.race([fetchPromise, timeoutPromise]);
      if (response instanceof Response) {
        const configData = await response.json();
        return configData;
      } else {
         return null;
      }
    }  else {
      const response = await network.get(cdnConfigUrl);
      return response.data;
    }
  } catch (error) {
    return null;
    throw error;
  }
}
export async function getWidevineURL(widevineConfig, country) {
  const defaultUrl = widevineConfig && widevineConfig?.LA_URL_default || "https://widevine-license.vudrm.tech/proxy";
  if (widevineConfig && widevineConfig?.defaultExcludeCountries &&  widevineConfig?.defaultExcludeCountries.includes(country)) {
     const countryKey = `LA_URL_${country}`
     return widevineConfig[countryKey]; 
  }
  return defaultUrl;
}
